// extracted by mini-css-extract-plugin
export default {"markdownWrap":"terms_of_service_modal___markdownWrap___d560ddd9","close":"terms_of_service_modal___close___c0a112eb","modal":"terms_of_service_modal___modal___e85daafc"};